/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpMobileStarRating_seller$ref = any;
type PdpRespDealerDetailsBio_seller$ref = any;
type PdpSharedDealerDetailsHeader_seller$ref = any;
type PdpSharedDealerDistinctions_seller$ref = any;
type PdpSharedDealerInfo_seller$ref = any;
export type PdpRespDealerDetailsStats_seller$ref = any;
export type PdpRespDealerDetailsStats_seller = {
    readonly " $fragmentRefs": PdpSharedDealerDistinctions_seller$ref & PdpSharedDealerInfo_seller$ref & PdpSharedDealerDetailsHeader_seller$ref & PdpMobileStarRating_seller$ref & PdpRespDealerDetailsBio_seller$ref;
    readonly " $refType": PdpRespDealerDetailsStats_seller$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespDealerDetailsStats_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDistinctions_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerInfo_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsHeader_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpMobileStarRating_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetailsBio_seller",
      "args": null
    }
  ]
};
(node as any).hash = '3a99ce9935072f0ddb8d1b9d74ccac5c';
export default node;
